import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { currentUrl } from "../../url";

// Токен будет читаться при каждом запросе, а не при загрузке модуля
interface IRawSphere {
  direction: {
    id: number;
    name: string;
  };
}
type ISphere = {
  direction: {
    id: number
    name: string
  }
}

interface ISpheresState {
  spheres: ISphere[]
  spheresLoading: boolean
  spheresError: boolean
}

export const fetchSpheres = createAsyncThunk<
  ISphere[],
  undefined,
  { rejectValue: boolean}
>("spheres/fetchSpheres", async function (_, { rejectWithValue }) {
  // Читаем токен при каждом запросе, чтобы использовать актуальное значение
  const accessToken = localStorage.getItem("accessToken");
  
  if (!accessToken) {
    return rejectWithValue(true); 
  }
  
  try {
    // Убеждаемся, что токен имеет правильный формат (Bearer префикс)
    const token = accessToken.startsWith("Bearer ") 
      ? accessToken 
      : `Bearer ${accessToken}`

    const res = await fetch(`${currentUrl}/master/directions`, {
      headers: {
        Authorization: token,
      },
    })

    if (!res.ok) {
      return rejectWithValue(true); // Если запрос завершился с ошибкой
    }


    const data = await res.json()
    const processedData: ISphere[] = data.map(
      (item:IRawSphere ): ISphere => ({
        direction: {
          id: item?.direction?.id,
          name: item?.direction?.name,
        },
      })
    )

    return processedData
  }
  catch (err) {
    return rejectWithValue(true); 
  }
})

const initialState: ISpheresState = {
  spheres: [],
  spheresLoading: false,
  spheresError: false
}

const spheresSlice = createSlice({
  name: 'spheresSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSpheres.pending, (state) => {
        state.spheresLoading = true
        state.spheresError = false
      })
      .addCase(fetchSpheres.fulfilled, (state, action) => {
        state.spheres = action.payload
        state.spheresLoading = false
      })
      .addCase(fetchSpheres.rejected, (state) => {
        state.spheresError = true
      })
  }
})

export default spheresSlice.reducer
